export enum ORG_LEVEL {
  TELCLOUD = 0,
  RESELLER = 1,
  SUB_ORG = 2,
  SECOND_SUB_ORG = 3,
}
